import { render, staticRenderFns } from "./jieguo.vue?vue&type=template&id=53cd8db2&scoped=true&"
import script from "./jieguo.vue?vue&type=script&lang=ts&"
export * from "./jieguo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cd8db2",
  null
  
)

export default component.exports